import * as React from "react";
import { forwardRef } from "react";
const SvgSendIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1200pt", height: "1200pt", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m1130.4 207.61-600 840c-12 16.781-33.609 24-54 18-19.172-6-32.391-25.219-32.391-45.609v-442.78l408-277.22-444 186-330-268.78c-15.609-13.219-21.609-33.609-14.391-52.781 6-19.219 24-32.438 44.391-32.438h984c18 0 34.781 9.6094 43.219 26.391 7.1719 15.609 6 34.828-4.8281 49.219z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgSendIcon);
export { ForwardRef as ReactComponent };
